import { LanguageProvider } from '@web_opxp/features';
import { Provider } from 'react-redux';
import { SUBSCRIBE_AVAILABLE_LANGUAGES } from './base/constants';
import ENV from './base/env';
import getStore from './store';
import SubscribeApp from './subscribe/SubscribeApp';

const SubscribeWrapper = () => {
  return (
    <Provider store={getStore()}>
      <LanguageProvider
        localesPath={ENV.LocalesBaseUrl}
        ns={['common', 'common.common', 'subscribe', 'prereg']}
        defaultNS="subscribe"
        fallbackNS="common"
        supportedLngs={SUBSCRIBE_AVAILABLE_LANGUAGES}>
        <SubscribeApp />
      </LanguageProvider>
    </Provider>
  );
};

export default SubscribeWrapper;
